<template>
  <div class="no-authority x-flex-y x-flex-center">
    <img src="@/assets/images/web/500.png" alt="" />
    <el-button type="primary" size="small" @click="backHome">{{$t('HT.userList.gohome')}}</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    backHome() {
      this.$router.push('/home');
    }
  }
};
</script>

<style lang="scss" scoped>
.no-authority {
  box-sizing: border-box;
  height: 100%;
  padding-bottom: 200px;

  > img {
    width: 530px;
    height: auto;
  }

  .el-button {
    margin: 60px 0 0 15px;
  }
}
</style>
